const config = {
  apiKey: 'AIzaSyDrCgKcol8SNb7i5HrAyJVcNRb183ALy-o',
  authDomain: 'itlekt-backend.firebaseapp.com',
  databaseURL: 'https://itlekt-backend.firebaseio.com',
  projectId: 'itlekt-backend',
  storageBucket: 'itlekt-backend.appspot.com',
  messagingSenderId: '1034812443050'
}

export default config



// WEBPACK FOOTER //
// ./src/firebase-config.js